/**
 * Created by Yoyo Fang on 06/02/2020
 * Description:
 *
 * ---------maintenance history-------------
 *
 */
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationMenuConfig, NavigationMenu } from '../navigation-menu.model';
import { Subscription } from 'rxjs/Subscription';
import { MENU_TOLERANCE } from '../../../tamalelibs/constants/business.constants';
import { Subject } from 'rxjs';


@Component({
    // tslint:disable-next-line: component-selector
    selector: 'navigation-menu-item',
    templateUrl: './navigation-menu-item.component.html',
    styleUrls: ['./navigation-menu-item.component.scss']
})
export class NavigationMenuItemComponent implements OnInit, OnDestroy {

    @Input() item: NavigationMenu;
    @Input() touchMode = false;
    @Input() seperator = false;
    @Input() eventSubject: Subject<any>;

    active = false;
    showSubItems = false;
    private _delayDismiss: any;
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(private _router: Router
    ) {
    }

    get expandable() {
        return this.item && (!!this.item.items && this.item.items.length > 0 || this.item.canAdd);
    }

    ngOnInit() {
        // const user = this._storeQuerierService.getCurrentUser();
        this._destroySubscriptions.push(this.eventSubject.subscribe((event) => {
            if (event.payload.routerLink) {
                this._showSubItems(false);
            }
        }));
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    // when user click the menu
    onClick(event) {
        this._stopEvent(event);
        if (!!this.item.routerLink) {
            this._router.navigate([this.item.routerLink]);
            this._showSubItems(false);
        }
        this.eventSubject.next({ type: 'click', payload: this.item });
    }

    onHover(event) {
        this.active = true;
        clearTimeout(this._delayDismiss);
        this._delayDismiss = setTimeout(() => {
            this._showSubItems(true);
        }, MENU_TOLERANCE);
    }

    onMoveOut(event) {
        this.active = false;
        if (this._delayDismiss) {
            clearTimeout(this._delayDismiss);
        }
        this._showSubItems(false);
    }

    private _showSubItems(show: boolean) {
        const result = show && this.expandable;
        this.showSubItems = result;
    }

    // stop propagation
    private _stopEvent($event) {
        if ($event.preventDefault) {
            $event.preventDefault();
        }
        if ($event.stopPropagation) {
            $event.stopPropagation();
        }
    }
}
